(() => {
  const chip_svg = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 37 40"><path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z"/></svg>`;

  let color_dictionary = {};
  async function loadColorDictionary() {
    try {
      const colorJsonUrl = document.getElementById('color-json-url')?.value;
      if (!colorJsonUrl) return;
      const response = await fetch(colorJsonUrl);
      if (!response.ok)
        throw new Error(
          `Erreur lors du chargement du dictionnaire: ${response.status}`
        );
      const data = await response.json();
      color_dictionary = data;
      window.color_dictionary = data;
    } catch (error) {
      console.error(
        'Erreur lors du chargement du dictionnaire de couleurs:',
        error
      );
    }
  }
  // --- Fonctions utilitaires ---

  function formatChipLabel(label) {
    return label
      .split(/[-_]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  function getSwatchColorsFromVariants(product) {
    const swatches = new Set();
    if (!product || !Array.isArray(product.variants)) return [];
    if (Array.isArray(product.options)) {
      const colorOption = product.options.find(
        (opt) => opt.name.toLowerCase() === 'color'
      );
      if (colorOption)
        colorOption.values.forEach((val) => swatches.add(val.toLowerCase()));
    }
    if (Array.isArray(product.options_with_values)) {
      const colorOption = product.options_with_values.find(
        (opt) => opt.name.toLowerCase() === 'color'
      );
      if (colorOption)
        colorOption.values.forEach((val) => swatches.add(val.toLowerCase()));
    }
    return Array.from(swatches);
  }

  function getMatchingSwatches(baseColor, colorDict, productSwatches) {
    if (
      !baseColor ||
      typeof baseColor !== 'string' ||
      !Array.isArray(productSwatches) ||
      productSwatches.length === 0
    )
      return [];
    const baseLower = baseColor.toLowerCase();
    const results = { exact: [], baseMatch: [], partial: [], related: [] };
    const normalizedSwatches = productSwatches.map((s) => s.toLowerCase());

    if (normalizedSwatches.includes(baseLower)) results.exact.push(baseLower);

    for (const swatch of normalizedSwatches) {
      if (results.exact.includes(swatch)) continue;
      if (swatch.includes(baseLower) || baseLower.includes(swatch))
        results.partial.push(swatch);
    }

    if (colorDict) {
      for (const [colorKey, colorEntry] of Object.entries(colorDict)) {
        const swatchLower = colorKey.toLowerCase();
        if (!normalizedSwatches.includes(swatchLower)) continue;
        if (
          results.exact.includes(swatchLower) ||
          results.partial.includes(swatchLower)
        )
          continue;
        const baseArray = Array.isArray(colorEntry?.base)
          ? colorEntry.base
          : (colorEntry?.base || '').split(',').map((x) => x.trim());
        const baseParts = baseArray.map((x) => x.toLowerCase());
        if (baseParts.includes(baseLower)) results.baseMatch.push(swatchLower);
      }
      const baseColorEntry = colorDict[baseLower];
      if (baseColorEntry && baseColorEntry.base) {
        const baseDefinition = Array.isArray(baseColorEntry.base)
          ? baseColorEntry.base
          : baseColorEntry.base.split(',').map((x) => x.trim());
        for (const [colorKey, colorEntry] of Object.entries(colorDict)) {
          const swatchLower = colorKey.toLowerCase();
          if (!normalizedSwatches.includes(swatchLower)) continue;
          if (
            results.exact.includes(swatchLower) ||
            results.partial.includes(swatchLower) ||
            results.baseMatch.includes(swatchLower)
          )
            continue;
          const swatchBases = Array.isArray(colorEntry?.base)
            ? colorEntry.base
            : (colorEntry?.base || '').split(',').map((x) => x.trim());
          if (
            swatchBases.some((base) =>
              baseDefinition.some((b) => b.toLowerCase() === base.toLowerCase())
            )
          )
            results.related.push(swatchLower);
        }
      }
    }
    return [
      ...results.exact,
      ...results.baseMatch,
      ...results.partial,
      ...results.related,
    ];
  }

  function buildCardColorPalette(product) {
    let cardPaletteHtml = '';
    let swatch_count = 0;
    let product_swatches = [];

    if (product.options) {
      const colorOption = product.options.find(
        (option) => option.name === 'Color' || option.name === 'color'
      );
      if (colorOption && colorOption.values) {
        swatch_count = parseInt(colorOption.values.length);
        product_swatches = colorOption.values;
      }
    }

    const hidden_asset_path = $('input#hidden-asset-url').val();
    if (!hidden_asset_path) {
      console.warn("Chemin d'asset manquant pour les nuanciers de couleurs");
      return '';
    }

    const asset_url = hidden_asset_path.substring(
      0,
      hidden_asset_path.indexOf('black.jpg')
    );

    if (swatch_count > 1) {
      cardPaletteHtml += `<div class='card-color-palette'>`;
      for (let index = 0; index < swatch_count; index++) {
        if (index <= 4) {
          const asset_name = product_swatches[index];
          if (!asset_name) continue;

          // ← NORMALISATION : remplace espaces par tirets et met en minuscules
          const normalized_asset_name = asset_name
            .replace(/\s+/g, '-') // Remplace tous les espaces par des tirets
            .toLowerCase(); // Met en minuscules

          cardPaletteHtml += `
        <img
          class='card-color'
          src='${asset_url + normalized_asset_name}.jpg'
          alt='Swatch of color ${asset_name}'
          loading='lazy'
          width='12'
          height='12'
          onerror="this.style.display='none'" />
      `;
        } else {
          break;
        }
      }
      if (swatch_count > 5) {
        cardPaletteHtml += `<div class='more-colors-label'>+ ${
          swatch_count - 5
        }</div>`;
      }
      cardPaletteHtml += `</div>`;
    }
    return cardPaletteHtml;
  }

  function gidToShopifyUrl(gid) {
    const id = gid.split('/').pop();
    return id
      ? `https://cdn.shopify.com/s/files/1/0032/0562/7968/files/${id}.jpg`
      : null;
  }

  function getImageTagForProduct(handle) {
    if (
      window.collectionMetafields &&
      Array.isArray(window.collectionMetafields.metafields)
    ) {
      const productMeta = window.collectionMetafields.metafields.find(
        (p) => p.handle === handle
      );
      return productMeta ? productMeta.image_tag : null;
    }
    return null;
  }

  // --- UI ---
  const UI = {
    elements: {
      formSideBar: null,
      formSortBy: null,
      grid: null,
      count: null,
      chips: null,
      clear: null,
    },

    initialize() {
      this.elements = {
        formSideBar: $('#CollectionFiltersSideBar'),
        formSortBy: $('#CollectionFiltersSortBy'),
        grid: $('ul.product-cards-container'),
        count: $('.filters-toolbar__product-count'),
        chips: $('#filter-chips-container'),
        clear: $('a.clear-filters'),
      };
      if (this.elements.grid.length) {
        this.elements.grid.removeAttr('style');
        Utils.hideLoading(this.elements.grid);
      }
    },

    initChips() {
      const $chips = this.elements.chips;
      if (!$chips || !$chips.length) return;
      $chips.empty();
      const params = new URLSearchParams(window.location.search);
      const chipDisplayMapping = {
        cocktail: 'Cocktail Dress',
        'evening-mob': 'Mother of the Bride/Groom',
        'mini': 'Mini Dress',
        'long-sleeve': 'Long Sleeve',
        'nouvelle-bridal': 'Nouvelle Amsale',
        'slits': 'Slits in Skirt',
        'amsale-bridal': 'AMSALE',
      };

      params.forEach((value, key) => {
        if (['min_price', 'max_price', 'sort'].includes(key)) return;

        value.split(',').forEach((val) => {
          let type = key;
          let label = val;
          let $input;

          if (type === 'collections') {
            $input = this.elements.formSideBar.find(
              `input[data-type="collections"][value="${val}"]`
            );
          } else {
            $input = this.elements.formSideBar.find(
              `[name="${key}"][value="${val}"]`
            );
          }

          if ($input.length) {
            if ($input.data('label')) {
              label = $input.data('label');
            }

            // 3) else try the <label for="…"> text
            else {
              const id = $input.attr('id');
              const $lbl = this.elements.formSideBar.find(`label[for="${id}"]`);
              if ($lbl.length) {
                label = $lbl.text().trim();
              }
            }
          }
          if (!label || label === val) {
            label = chipDisplayMapping[val] || formatChipLabel(val);
          }

          $chips.append(`
        <div class="filter-chip" data-type="${type}" data-value="${val}">
          ${label}
          <button class="remove-filter-btn" data-type="${type}" data-value="${val}">
            ${chip_svg}
          </button>
        </div>
      `);
        });
      });

      const min = params.get('min_price');
      const max = params.get('max_price');
      if (min || max) {
        const rangeMin = UI.elements.formSideBar.find('.range-min')[0];
        const rangeMax = UI.elements.formSideBar.find('.range-max')[0];
        const minDisplay = min || (rangeMin ? rangeMin.min : '0');
        const maxDisplay = max || (rangeMax ? rangeMax.max : '9999');
        let priceLabel = '';
        if (min && max && min === max) {
          priceLabel = `$${min}`;
        } else {
          priceLabel = `$${minDisplay} - $${maxDisplay}`;
        }
        $chips.append(`
      <div class="filter-chip" data-type="price">
        ${priceLabel}
        <button class="remove-filter-btn" data-type="price">${chip_svg}</button>
      </div>
    `);
      }
      const sort = params.get('sort');
      if (sort) {
        let sortLabel = '';
        if (sort === 'price_low_high') sortLabel = 'Price: Low to High';
        else if (sort === 'price_high_low') sortLabel = 'Price: High to Low';
        else sortLabel = 'Sort: ' + sort;
        $chips.append(`
     <div class="filter-chip" data-type="sort">
       ${sortLabel}
       <button class="remove-filter-btn" data-type="sort">${chip_svg}</button>
     </div>
   `);
      }
      if (params.toString() !== '') {
        $chips.prepend(`
  <a href="#" class="clear-filters" aria-label="Clear all filters">Clear all</a>
`);
      }

      this.elements.clear = this.elements.clear || $('a.clear-filters');
      this.elements.clear.toggleClass('show', params.toString() !== '');
    },

    renderProducts(products, totalCount) {
      const $grid = this.elements.grid;
      const $count = this.elements.count;
      if (!$grid.length) return;
      $grid.empty();
      if (!products || !products.length) {
        $grid.html('<li class="no-results">No Results Found</li>');
        $count.text('0 produit');
        return;
      }
      products.forEach((product) => {
        const mainImage =
          product.images && product.images.length > 0
            ? product.images[0].src
            : '';
        const price =
          product.price ||
          (product.variants && product.variants[0]
            ? product.variants[0].price
            : null);
        const formattedPrice = price ? `$${Math.round(price)}` : '';
        const imgId = `img-${product.handle}`;
        let imageTag = product.metafields?.amsale?.image_tag?.value;
        if (!imageTag && window.collectionMetafields) {
          imageTag = getImageTagForProduct(product.handle);
        }
        let colorPalette = '';
        if (
          product.options &&
          product.options.some((opt) => opt.name.toLowerCase() === 'color')
        ) {
          colorPalette = buildCardColorPalette(product);
        }
        $grid.append(`
      <li class="product-card-list-item grid__item medium-up--one-third" 
          data-product-handle="${product.handle}" 
          data-product-id="${product.id || ''}">
        <div class="custom__product-card">
          <a href="/products/${product.handle}" data-product-handle="${
          product.handle
        }" >
            <div style="position: relative;">
              <div class="hover-reveal-effect">
                <img id="${imgId}" class="grid-view-item__image lazyload productFullImg" 
                    src="${mainImage}" 
                    alt="${product.title}" 
                    loading="lazy"/>
                ${
                  product.images && product.images.length > 1
                    ? `<img class="grid-view-item__image lazyload productFullImg hidden-reveal-image" 
                        src="${product.images[1].src}" 
                        alt="${product.title}" 
                        loading="lazy" 
                        tabindex="-1"/>`
                    : ''
                }
                ${
                  imageTag
                    ? `
              <span class="image-tag">${imageTag || ''}</span>
            `
                    : ''
                }
            </div>
            </div>
            <div class="product-card__title_wrapper">
              <div class="card-flex-wrapper">
                <h4>${product.title}</h4>
                ${colorPalette}
              </div>
              <div class="card-flex-wrapper price-wrapper">
                <h5>${formattedPrice}</h5>
              </div>
            </div>
          </a>
        </div>
      </li>
    `);
      });

      const productText = totalCount === 1 ? 'produit' : 'produits';
      $count.text(`${totalCount} ${productText}`);
      $('.filters-toolbar__product-count').not($count).hide();
      this.loadVariantImages(products);
    },

    loadVariantImages(products) {
      const urlParams = new URLSearchParams(window.location.search);
      const colorParam = urlParams.get('color');
      let filteredColors = [];
      if (colorParam) {
        filteredColors = colorParam
          .split(',')
          .map((c) => c.trim().toLowerCase());
      }
      const productCards = Array.from($('.product-card-list-item'));
      const batchSize = 5;

      const processBatch = async (startIndex) => {
        const batch = productCards.slice(startIndex, startIndex + batchSize);
        await Promise.all(
          batch.map(async (card) => {
            const $card = $(card);
            const handle = $card.data('product-handle');
            if (!handle) return;
            const $image = $card.find('.productFullImg').first();
            if (!$image.length) return;
            const imgId = $image.attr('id');
            if (!imgId) return;
            try {
              const productData = products.find((p) => p.handle === handle);
              if (!productData) return;
              const productSwatches = getSwatchColorsFromVariants(
                productData
              ).map((s) => s.toLowerCase());
              let colorToUse = '';
              const lastClickedColor = localStorage.getItem('lastClickedColor');
              if (
                filteredColors.length > 0 &&
                lastClickedColor &&
                filteredColors.includes(lastClickedColor)
              ) {
                if (productSwatches.includes(lastClickedColor)) {
                  colorToUse = lastClickedColor;
                } else {
                  const match = getMatchingSwatches(
                    lastClickedColor,
                    color_dictionary,
                    productSwatches
                  )[0];
                  if (match) colorToUse = match;
                }
              }
              if (!colorToUse && filteredColors.length > 0) {
                for (let i = filteredColors.length - 1; i >= 0; i--) {
                  const filterColor = filteredColors[i];
                  if (productSwatches.includes(filterColor)) {
                    colorToUse = filterColor;
                    break;
                  }
                  const match = getMatchingSwatches(
                    filterColor,
                    color_dictionary,
                    productSwatches
                  )[0];
                  if (match) {
                    colorToUse = match;
                    break;
                  }
                }
                if (!colorToUse) {
                  colorToUse = productSwatches[0] || '';
                }
              } else if (!colorToUse) {
                const lastColor = localStorage.getItem('lastSelectedColor');
                if (lastColor && productSwatches.includes(lastColor)) {
                  colorToUse = lastColor;
                } else {
                  colorToUse = productSwatches[0] || '';
                }
              }
              if (colorToUse) {
                await injectSwatchImage(productData, colorToUse, imgId);
              }
            } catch (err) {
              console.error(
                `Erreur lors du chargement de l'image pour ${handle}:`,
                err
              );
            }
          })
        );
        if (startIndex + batchSize < productCards.length) {
          setTimeout(() => processBatch(startIndex + batchSize), 100);
        }
      };
      if (productCards.length > 0) processBatch(0);
    },
  };

  async function injectSwatchImage(product, baseColor, imgElementId) {
    const imgEl = document.getElementById(imgElementId);
    if (!imgEl) return;
    const normalizedBase = baseColor;
    const productSwatches =
      Array.isArray(product.swatches) && product.swatches.length > 0
        ? product.swatches.map((s) => s.toLowerCase())
        : getSwatchColorsFromVariants(product).map((s) => s.toLowerCase());

    const colorDictionary = color_dictionary || {};
    const exactMatch = productSwatches.includes(normalizedBase);
    let tryList = exactMatch
      ? [normalizedBase]
      : getMatchingSwatches(baseColor, colorDictionary, productSwatches);

    if (tryList.length === 0) {
      return;
    }

    let matchedColor = null;
    for (const colorToTry of tryList) {
      const lowerColor = colorToTry.toLowerCase();
      const variant = product.variants.find((v) => {
        const o1 = v.option1?.toLowerCase() || '';
        const o2 = v.option2?.toLowerCase() || '';
        const o3 = v.option3?.toLowerCase() || '';
        return (
          o1 === lowerColor ||
          o2 === lowerColor ||
          o3 === lowerColor ||
          (v.title && v.title.toLowerCase().includes(lowerColor))
        );
      });

      if (variant) {
        // Cherche une image dans les métadonnées
        const variantMeta =
          window.collectionMetafields &&
          window.collectionMetafields.metafields &&
          window.collectionMetafields.metafields.find(
            (m) => m.id == variant.id
          );

        if (variantMeta && variantMeta.metafields) {
          let images = variantMeta.metafields;
          if (typeof images === 'string') {
            try {
              images = JSON.parse(images);
            } catch (e) {}
          }
          if (Array.isArray(images) && images.length > 0) {
            const imageUrl = gidToShopifyUrl(images[0]);
            if (imgEl && imageUrl) {
              imgEl.src = imageUrl;
              imgEl.alt = `${product.title} – ${baseColor}`;
            }
          }
        }
        matchedColor = lowerColor;
      }
    }

    let src = null;
    const matchedVariant = product.variants.find((v) => {
      const o1 = v.option1?.toLowerCase() || '';
      const o2 = v.option2?.toLowerCase() || '';
      const o3 = v.option3?.toLowerCase() || '';
      return (
        o1 === matchedColor ||
        o2 === matchedColor ||
        o3 === matchedColor ||
        (v.title && v.title.toLowerCase().includes(matchedColor))
      );
    });

    if (matchedVariant && matchedVariant.featured_image) {
      src =
        typeof matchedVariant.featured_image === 'string'
          ? matchedVariant.featured_image
          : matchedVariant.featured_image.src ||
            matchedVariant.featured_image.url;
    }
    if (!src && Array.isArray(product.images)) {
      const byId = product.images.find(
        (img) =>
          Array.isArray(img.variant_ids) &&
          img.variant_ids.includes(matchedVariant?.id)
      );
      if (byId && byId.src) src = byId.src;
    }
    if (!src && Array.isArray(product.images)) {
      const byName = product.images.find((img) => {
        const s = (img.src || '').toLowerCase();
        return s.includes(matchedColor?.toLowerCase());
      });
      if (byName && byName.src) src = byName.src;
    }
    if (!src && product.featured_image) {
      src =
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image.src || product.featured_image.url;
    } else if (
      !src &&
      Array.isArray(product.images) &&
      product.images.length > 0
    ) {
      const firstImg = product.images[0];
      src = typeof firstImg === 'string' ? firstImg : firstImg.src;
    }
    if (src) {
      imgEl.src = src;
      imgEl.alt = `${product.title} – ${matchedColor || ''}`;
      imgEl.onerror = () => {
        imgEl.onerror = null;
        injectVariantImageFallback(product, imgEl);
      };
    }
  }

  async function injectVariantImageFallback(product, imgEl) {
    if (!product || !imgEl) return;
    let src =
      product.featured_image ||
      (Array.isArray(product.images) && product.images[0]?.src) ||
      null;
    if (src) {
      imgEl.src = src;
      imgEl.alt = product.title;
    }
  }

  // --- Utils generics ---
  const Utils = {
    debounce(fn, wait = 300) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    },
    serializeAllForms() {
      const sidebarForm = UI.elements.formSideBar[0];
      const sortForm = UI.elements.formSortBy[0];

      if (!sidebarForm && !sortForm) return '';

      const combinedFormData = new FormData();

      if (sidebarForm) {
        const sidebarData = new FormData(sidebarForm);
        for (let [key, value] of sidebarData.entries()) {
          if (key !== 'current-collection' && key !== 'current-collection-id') {
            combinedFormData.append(key, value);
          }
        }

        const rangeMin = sidebarForm.querySelector('.range-min');
        const rangeMax = sidebarForm.querySelector('.range-max');
        if (rangeMin && rangeMin.value !== rangeMin.min) {
          combinedFormData.append('min_price', rangeMin.value);
        }
        if (rangeMax && rangeMax.value !== rangeMax.max) {
          combinedFormData.append('max_price', rangeMax.value);
        }
      }

      if (sortForm) {
        const sortData = new FormData(sortForm);
        for (let [key, value] of sortData.entries()) {
          if (value && value.trim() !== '') {
            combinedFormData.append(key, value);
          }
        }
      }

      const nameMapping = {
        'size-check': 'size',
        size: 'size',
        'fabric-check': 'fabric',
        fabric: 'fabric',
        'length-check': 'length',
        'silhouette-check': 'silhouette',
        'neckline-check': 'neckline',
        'occasion-check': 'occasion',
        'dress-check': 'dress_type',
        'aesthetic-check': 'aesthetic',
        'detail-check': 'details',
        color: 'color',
        sort: 'sort',
        collections: 'collections',
      };

      const paramsMap = {};
      for (let [key, value] of combinedFormData.entries()) {
        if (!value || value.trim() === '') continue;
        let paramName = nameMapping[key] || key;
        if (!paramsMap[paramName]) paramsMap[paramName] = [];
        paramsMap[paramName].push(value);
      }
      const params = new URLSearchParams();
      for (const [key, values] of Object.entries(paramsMap)) {
        let urlValue = values;
        if (key === 'dress_type') {
          urlValue = values.map((v) => {
            if (v === 'cocktail-dress') return 'cocktail';
            if (v === 'mother-of-the-bride-groom') return 'evening-mob';
            if (v === 'sleeved-dress') return 'sleeved-dress';
            return v;
          });
        }
        if (key === 'silhouette') {
          urlValue = values.map((v) => {
            if (v === 'mini-dress') return 'mini';
            return v;
          });
        }
        if (key === 'neckline') {
          urlValue = values.map((v) => {
            if (v === 'sleeved-gown') return 'sleeved-dress';
            return v;
          });
        }
        if (key === 'details') {
          urlValue = values.map((v) => {
            if (v === 'slits-in-skirt') return 'slits';
            return v;
          });
        }
        if (key === 'aesthetic') {
          urlValue = values.map((v) => {
            if (v === 'clean-minimal') return 'clean';
            return v;
          });
        }
        if (key === 'collections') {
          urlValue = values.map((v) => {
            if (v === 'nouvelle-amsale') return 'nouvelle-bridal';
            if (v === 'amsale') return 'amsale-bridal';
            return v;
          });
        }
        params.append(key, urlValue.join(','));
      }
      return params.toString();
    },
    showLoading($el) {
      if ($el && $el.length) $el.css('opacity', 0.5);
    },
    hideLoading($el) {
      if ($el && $el.length) {
        $el.css('opacity', 1);
        $el.removeAttr('style');
      }
    },
    logFormData() {
      const form =
        document.getElementById('CollectionFiltersSideBar') ||
        document.getElementById('CollectionFiltersSortBy');
      if (!form) return;
      const formData = new FormData(form);
    },
  };

  // --- Main ---
  const App = {
    init() {
      loadColorDictionary().then(() => {
        UI.initialize();
        if (!UI.elements.formSideBar.length) {
          console.error('Formulaire sidebar de filtrage non trouvé');
          return;
        }

        if (!UI.elements.formSortBy.length) {
          console.warn('Formulaire de tri non trouvé - tri désactivé');
        }
        this.bindEvents();
        UI.initChips();
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.toString() !== '') {
          this.fetchAndRender();
        }
      });
    },

    bindEvents() {
      UI.elements.formSideBar.on(
        'change',
        'input[type="checkbox"].checkb-filter',
        Utils.debounce((e) => {
          const target = e.target;
          if (target.name === 'color') return;
          if (!target.id.startsWith('chk_')) {
            this.fetchAndRender();
          }
        }, 300)
      );

      UI.elements.formSideBar.on(
        'change',
        'input[type="checkbox"].checkb-filter[name="color"]',
        Utils.debounce((e) => {
          const target = e.target;
          if (target.checked) {
            localStorage.setItem(
              'lastClickedColor',
              target.value.toLowerCase()
            );
          } else {
            localStorage.removeItem('lastClickedColor');
          }
          if (!target.id.startsWith('chk_')) {
            this.fetchAndRender();
          }
        }, 300)
      );

      UI.elements.formSortBy.on(
        'change',
        'select[name="sort"]',
        Utils.debounce((e) => {
          e.preventDefault();
          e.stopPropagation();
          this.fetchAndRender();
        }, 300)
      );
      const updateMinDisplay = (val) =>
        UI.elements.formSideBar.find('.lowest-range').text(`$${val}`);
      const updateMaxDisplay = (val) =>
        UI.elements.formSideBar.find('.highest-range').text(`$${val}`);
      UI.elements.formSideBar.on(
        'input',
        'input.range-min',
        Utils.debounce((e) => {
          const val = e.target.value;
          updateMinDisplay(val);
          App.fetchAndRender();
        }, 200)
      );

      UI.elements.formSideBar.on(
        'input',
        'input.range-max',
        Utils.debounce((e) => {
          const val = e.target.value;
          updateMaxDisplay(val);
          App.fetchAndRender();
        }, 200)
      );
      UI.elements.formSideBar.on('submit', (e) => {
        e.preventDefault();
        this.fetchAndRender();
        this.closeDrawer();
      });
      $(document).on('click', 'button.apply-filters-btn', (e) => {
        e.preventDefault();
        Utils.logFormData();
        this.fetchAndRender();
        this.closeDrawer();
      });
$(document).on('click', '.remove-filter-btn', function (e) {
  e.preventDefault();
  const { type, value } = this.dataset;
  console.log(`Removing filter: ${type} = ${value}`);

  if (type === 'price') {
    UI.elements.formSideBar
      .find('.range-min').val(function() { return this.min })
      .end()
      .find('.range-max').val(function() { return this.max })
      .end()
      .find('.range-min, .range-max').trigger('input');
  } else if (type === 'sort') {
    UI.elements.formSortBy.find('select[name="sort"]').val('');
  } else {
    // Récupère le texte du chip (le parent du bouton)
    const chipText = $(this).parent('.filter-chip').text().trim();
    
    // Transforme le texte en format "handleize" (minuscules avec tirets)
    const handleizedText = chipText
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
    
    // Cherche la checkbox par sa valeur "handleized"
    const $checkbox = UI.elements.formSideBar.find(
      `input[type="checkbox"][value="${handleizedText}"], 
       input[type="checkbox"][value="${value}"]`
    );
    
    // Cherche l'input caché par sa valeur
    const $hidden = UI.elements.formSideBar.find(
      `input[type="hidden"][value="${handleizedText}"], 
       input[type="hidden"][value="${value}"]`
    );
    
    console.log(`Removing filter: ${type}, text: ${chipText}, handleized: ${handleizedText}`);
    
    if ($checkbox.length) {
      $checkbox.prop('checked', false);
    } else if ($hidden.length) {
      $hidden.remove();
    }
  }

  // re-run the filter
  App.fetchAndRender();
});

      $(document).on('click', '.clear-filters', (e) => {
        e.preventDefault();
        UI.elements.formSideBar[0].reset();
        UI.elements.formSortBy[0].reset();

        const rangeMin = UI.elements.formSideBar.find('.range-min')[0];
        const rangeMax = UI.elements.formSideBar.find('.range-max')[0];
        if (rangeMin) rangeMin.value = rangeMin.min;
        if (rangeMax) rangeMax.value = rangeMax.max;
        history.replaceState(null, '', window.location.pathname);
        localStorage.removeItem('lastClickedColor');
        localStorage.removeItem('lastSelectedColor');
        App.fetchAndRender();
      });
      $(document).on('click', 'button.open-refine-section', () =>
        this.openDrawer('.filter-refine-section')
      );
      $(document).on('click', 'button.open-filters-section', () =>
        this.openDrawer('.filter-section')
      );
      $(document).on('click', 'button#close-drawer-btn', () =>
        this.closeDrawer()
      );
    },

    openDrawer(selector) {
      $('#shopify-section-header').addClass('hide-header');
      $(selector).addClass('show-section');
      $('.grid__item--sidebar').addClass('open-drawer');
      $('html, body').addClass('sidebar-open');
      $('#zsiq_float').hide();
    },

    closeDrawer() {
      $('#shopify-section-header').removeClass('hide-header');
      $('.filter-refine-section, .filter-section').removeClass('show-section');
      $('.grid__item--sidebar').removeClass('open-drawer');
      $('html, body').removeClass('sidebar-open');
      $('#zsiq_float').css('display', 'inline-block');
    },

    async fetchAndRender() {
      if (
        !UI.elements.formSideBar.length ||
        !UI.elements.formSortBy.length ||
        !UI.elements.grid.length
      ) {
        console.error('Éléments manquants pour le filtrage');
        return;
      }
      const collectionId = $('input[name="current-collection-id"]').val();
      if (!collectionId) {
        console.error('ID de collection manquant');
        return;
      }
      const query = Utils.serializeAllForms();
      const apiUrl = `https://api.ecom.amsale.com/api/inventory/${collectionId}/products?${query}`;
      const pageUrl = `${window.location.pathname}?${query}`;
      Utils.showLoading(UI.elements.grid);

      try {
        if (!color_dictionary || Object.keys(color_dictionary).length === 0) {
          await loadColorDictionary();
        }
        const response = await fetch(apiUrl, {
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Erreur API ${response.status}`);
        const data = await response.json();
        if (!data.products || !Array.isArray(data.products)) {
          console.error('Format de réponse API invalide', data);
          return;
        }
        UI.renderProducts(
          data.products,
          data.total_count || data.products.length
        );
        history.replaceState(null, '', pageUrl);
        UI.initChips();
        setTimeout(() => UI.loadVariantImages(data.products), 0);

        // Si tout va bien, réactive les filtres au cas où ils étaient désactivés
        UI.elements.formSideBar
          .find('input, select, button')
          .prop('disabled', false);
        UI.elements.formSortBy
          .find('input, select, button')
          .prop('disabled', false);
        $('#filter-error-notice').remove();
      } catch (err) {
        console.error('Filtrage API échoué :', err);

        // Désactive tous les filtres
        UI.elements.formSideBar
          .find('input, select, button')
          .prop('disabled', true);
        UI.elements.formSortBy
          .find('input, select, button')
          .prop('disabled', true);

        // Affiche un message d'erreur si pas déjà présent
        if (!$('#filter-error-notice').length) {
          UI.elements.grid.before(`
        <div id="filter-error-notice" style="color: #b00; background: #fff3f3; padding: 1em; margin-bottom: 1em; border: 1px solid #b00;">
  Filters are temporarily disabled because the search service is unavailable. Please try again later.
</div>
      `);
        }
      } finally {
        Utils.hideLoading(UI.elements.grid);
      }
    },
  };

  $(function () {
    setTimeout(() => App.init(), 100);
  });
})();
